import React, { useEffect, useState, useCallback } from "react";
import "./Login.css";

import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Redux
import { useDispatch } from "react-redux";
import { fetchAuthInfo, authenticateUser } from "../../store/apiActions.js";

// Utils
import { getCopyrightText } from "../../utils/helper";
import { tokenManager } from "../../utils/Utility";
import { handleAuthError } from "../../utils/apiHelper.js"

// Constants
import { useConstants } from "../../constant/constantProvider";
import { STORAGE_KEYS, ROUTES } from "../../constant/keyConstants";

// Assets
import vectorImage from "../../assets/images/Vector.png";

function Login() {
  const [loginState, setLoginState] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { login: t = {} } = useConstants();

  const fetchUserTokenAndAuthenticate = useCallback(async (code) => {
    setLoginState(true);
    try {
      const body = { code: code };
      const response = await dispatch(authenticateUser(body));
      const item = response;
      tokenManager.setToken(item.token);
      localStorage.setItem(STORAGE_KEYS.LOGGED_IN_DETAILS, JSON.stringify(item.app_user));
      localStorage.setItem(STORAGE_KEYS.IS_LOGIN, true);
      setLoginState(false);
      navigate(ROUTES.DASHBOARD);
      toast.success(t.SUCCESS_LOGIN || "You are successfully logged in");
    } catch (error) {
      setLoginState(false);
      toast.error(error.message);
    } finally {
      setLoginState(false);
    }
  }, [dispatch, navigate, t.SUCCESS_LOGIN]);

  const checkAndLoginUser = useCallback(() => {
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get("code");
    if (code) {
      setLoginState(true);
      fetchUserTokenAndAuthenticate(code);
    }
  }, [location.search, fetchUserTokenAndAuthenticate]);

  useEffect(() => {
    checkAndLoginUser();
  }, [checkAndLoginUser]);

  const fetchAuthenticatedAPI = () => {
    dispatch(fetchAuthInfo())
      .then((response) => {
        ssoSignIn(response);
      })
      .catch((error) => {
        setLoginState(true);
        console.error("There was an error!", error);
        handleAuthError(error, toast);
      });
  };

  const ssoSignIn = (props) => {
    const item = props;
    const loginUrl = item.login_url;
    if (loginUrl) {
      window.location.href = loginUrl;
    }
  };

  return (
    <>
      <ToastContainer closeButton={true} position="top-right" />
      {!loginState ? (
        <div className="login-container">
          <div className="login-parent-container">
            <div className="login-card-wrapper">
              <div className="login-card">
                <div>
                  <img src={vectorImage} alt="Vector logo" className="login-logo-img" />
                </div>
                <div className="login-title">
                  <span>{t.APP_TITLE_PREFIX || "DOSSIER"}</span>
                  <span className="login-title-highlight">{t.APP_TITLE_SUFFIX || "GenAI"}</span>
                </div>
                <div className="login-subtitle">
                  <span>{t.LOG_IN_TO_CONTINUE || "Log in to continue"}</span>
                </div>
                <div className="login-button-wrap">
                  <button
                    className="login-btn"
                    onClick={fetchAuthenticatedAPI}
                  >
                    {t.LOG_IN || "Log In"}
                  </button>
                </div>
              </div>
              <div className="login-copyright">
                {getCopyrightText()}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="login-loading">
          {t.PLEASE_WAIT || "Please wait for a while..."}
        </div>
      )}
    </>
  );
}

export default Login;
